import { render, staticRenderFns } from "./general-data-form.vue?vue&type=template&id=19a24595&"
import script from "./general-data-form.vue?vue&type=script&lang=js&"
export * from "./general-data-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports